const SUBCATEGORY_ROUTES={
    ADD_SUBCATEGORY: 'subcategories/add',
    GET_SUBCATEGORY: 'subcategories/list',
    UPDATE_SUBCATEGORY: 'subcategories/update',
    DELETE_SUBCATEGORY: 'subcategories/delete',
}
export default SUBCATEGORY_ROUTES;